// extracted by mini-css-extract-plugin
export var quillEditor = "_md-1";
export var variable = "_md-0";